<template>
	<v-dialog
		v-model="isVisible"
		max-width="600"
	>
		<guideline-job-selector
			:selected-job="selectedJob"
			@selectedJobDataChanged="onSelectedJobDataChanged"
			ref="jobSelector"
		>
			<template slot="action-footer">
				<v-btn
					class="custom-button tw-px-8"
					color="primary"
					@click="onSaveClick"
				>Guardar</v-btn>
			</template>
		</guideline-job-selector>
	</v-dialog>
</template>

<script>
import GuidelineJobSelector from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-selector';

export default {
	name: 'job-selector-edition-dialog',
	components: { GuidelineJobSelector },
	data() {
		return {
			isVisible: false,
			selectedJob: {},
		};
	},
	methods: {
		show(selectedJob) {
			this.selectedJob = selectedJob;
			this.isVisible = true;
		},
		hide() {
			this.isVisible = false;
		},
		onSelectedJobDataChanged(selectedJobUpdated) {
			this.selectedJob = selectedJobUpdated;
		},
		onSaveClick() {
			this.$store.dispatch('jobEvaluation/updateJobItem', this.selectedJob);
			this.$store.dispatch('jobEvaluation/assignHierarchy')
				.then(() => {
					this.$store.dispatch('jobEvaluation/getGuidelineModelStatus');
					this.isVisible = false;
				})
				.catch(error => console.error(error));
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-selector-edition-dialog.vue